import { render } from "./MonthlyGeneral.vue?vue&type=template&id=4e113fd0&scoped=true"
import script from "./MonthlyGeneral.vue?vue&type=script&lang=js"
export * from "./MonthlyGeneral.vue?vue&type=script&lang=js"

import "./MonthlyGeneral.vue?vue&type=style&index=0&id=4e113fd0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\abbas\\Desktop\\kswc\\kswc_dashboard-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e113fd0"]])

export default __exports__